import { timeoutPromise } from './timeout-promise';
const RETRY_TIMEOUT = 2500;
export const retry = (fn, url, retries = 1, timeout = RETRY_TIMEOUT, abortSignal = {}, isAborted) => {
    return new Promise((resolve, reject) => timeoutPromise(fn(), timeout, `Fetch timed out after ${timeout}ms at url: ${url}`, abortSignal).then((response) => {
        resolve(response);
    }, (error) => {
        if (error.response && error.response.status >= 500 && retries > 0) {
            return retry(fn, url, retries - 1, timeout, abortSignal).then(resolve, reject);
        }
        if (error.response && error.response.status >= 400) {
            reject(error.response);
        }
        if (isAborted && isAborted(error)) {
            return reject(new DOMException('Aborted', 'AbortError'));
        }
        if (retries > 0) {
            return retry(fn, url, retries - 1, timeout, abortSignal).then(resolve, reject);
        }
        reject(augmentError(error));
    }));
};
const augmentError = (error) => {
    if ((error === null || error === void 0 ? void 0 : error.code) === 'ECONNABORTED') {
        try {
            error.name = 'TimeoutError';
        }
        catch (_) { }
    }
    return error;
};
//# sourceMappingURL=retry-request.js.map